import React, { useState } from "react";
import { Modal, Offcanvas } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import {
  CURRENCY_NAME,
  CUSTOM_SELECT_STYLES,
  PUSH_NOTIFICATION_MODULE,
  SELECT_BOX_THEME,
  SUBSCRIPTION_MODULE_TYPE,
  SUPPORTED_PAYMENT_METHOD_LIST,
} from "../../constants";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { createChat } from "../../services/api";
import { addSubscriptionAction, previewSubscriptionAction } from "../../actions/subscriptionPlan";
import Form from "react-bootstrap/Form";
import CustomToggle from "../../components/timeFormat/ToggleSwitch";
import PlanSummary from "../../components/companyModal/CompanyModal";
import { RoutesPaths } from "../../Router/constant";
import toast from "react-hot-toast";

export const paymentLink = (data) => {
  return `<a class="chatPaymentLink" href="javascript:void(0)" slug="${data?.slug}">Admin has requested a payment</a>`;
};
export default function CreatePayment({ show, onClose, conversation, isChatPage }) {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const onCancel = () => {
    reset();
    onClose();
  };
  const [isKimbocorp, setIsKimbocorp] = useState(false);
  const [showNewSlider, setShowNewSlider] = useState(false);
  const { user } = useSelector((state) => state.user);
  const { selectedCompany } = useSelector((state) => state.company);
  const { planPreview, planPreviewLoader, planPayload } = useSelector((state) => state.stripe);
  const [planCreateLoader, setPlanCreateLoader] = useState(false)
  const onSubmit = async (data) => {
    const allData = {
      planType: { value: SUBSCRIPTION_MODULE_TYPE.CUSTOM, name: "Custom" },
      name: data.planName,
      isActive: true,
      currency: data.currency,
      price: data.price,
      targetAudience: data.targetAudience,
      supportedPaymentMethod: SUPPORTED_PAYMENT_METHOD_LIST,
      type: isKimbocorp ? "kimbocorp" : "advisor",
      company: conversation?.company ? conversation?.company : selectedCompany,
      smallDescription:
        "this plan allows you to access premium features, including advanced analytics, priority support, and enhanced email-sending capabilities. Upgrade now to maximize your experience!",
    };
    previewPlanFunc(allData)
  };

  const createPlan = async (isSubmit = false) => {
    setPlanCreateLoader(true)
    const allData = {
      planType: { value: SUBSCRIPTION_MODULE_TYPE.CUSTOM, name: "Custom" },
      name: planPayload.name,
      isActive: planPayload?.isActive,
      currency: planPayload.currency,
      price: planPayload.price,
      targetAudience: planPayload.targetAudience,
      supportedPaymentMethod: planPayload?.supportedPaymentMethod,
      type: planPayload?.type,
      smallDescription: planPayload?.smallDescription,
      company: conversation?.company?.id ? conversation?.company?.id : selectedCompany?.id
    };

    const result = await dispatch(addSubscriptionAction(allData));
    if (result?.status) {
      if (isSubmit) {
        const data = paymentLink(result.data);
        const innerValue = `Quotation: ${planPayload.name}`;
        if (innerValue.length === 0) {
          return;
        }

        const attributes = {
          companyId: conversation?.company?.id ? conversation?.company?.id : selectedCompany?.id,
          module: PUSH_NOTIFICATION_MODULE.PAYMENTLINK, // Custom attribute
          data: result.data,
          participants: conversation?.participants
            ?.filter((x) => x.id !== user?.id)
            .map((x) => x.id),
          message: innerValue,
        };
        await createChat(attributes);
        onCancel();
        setShowNewSlider(false);
        reset();
        onClose();
        setPlanCreateLoader(false)
      } else {
        let shortUrl = window?.location?.origin + RoutesPaths.PAY_BANKTRANSFER_PUBLIC.replace(":slug", result.data?.slug);
        navigator.clipboard
          .writeText(shortUrl)
          .then(() => {
            toast.success("URL copied to clipboard");
          })
          .catch(() => {
            console.error("Failed to copy text: ");
          });
        onCancel();
        setShowNewSlider(false);
        reset();
        onClose();
        setPlanCreateLoader(false)
      }
    }
  }

  const KimbocorpToggle = ({ checked, onChange }) => {
    return (
      <div className="toggle-section d-flex justify-content-between align-items-center flex-wrap">
        <div className="text-section">
          <h6 className="">Is this a kimbocorp plan</h6>
          {checked &&
            <p className="">You will earn 25% commission</p>
          }
        </div>
        <div className="switch-section">
          <CustomToggle
            checked={checked}
            onChange={onChange} // receives native event (e.target.checked)
            onColor="#1d8cf8" // custom ON track color
            offColor="#d9e2ec" // custom OFF track color
            size="md" // optional: sm | md | lg
          />
        </div>
      </div>
    );
  };

  const previewPlanFunc = async (data) => {
    let payload = {
      type: data?.type, // kimbocorp, advisor
      price: data?.price,
      currency: data.currency,
    }
    await dispatch(previewSubscriptionAction(payload, data))
    setShowNewSlider(true);
  }
  return (
    <>
      <Offcanvas
        show={show}
        onHide={onClose}
        placement="end" // 👈 this makes it slide in from the right
        className="companyEdit-offcanvas filter-offcanvas canvasSidebar filter-modal"
      >
        <div className="offcanvas-header pt-2 custom-canvas-header1">
          <div className="compSideBarHeader">
            Maninder company
            <p className="m-0">
              Turn business ideas into income – with just one share.
            </p>
          </div>
          <button
            type="button"
            className="btn-close text-dark close-button"
            onClick={onClose}
          >
            &nbsp;
            {/* <span aria-hidden="true">×</span> */}
          </button>
        </div>
        <div className="offcanvas-body custom-canvas-header">
          <div className="row">
            <div className="col-12 fieldPadding">
              <label className="labelForm" htmlFor="">
                Purpose*
              </label>
              <Controller
                control={control}
                className="form-control"
                name="planName"
                rules={{ required: true }}
                render={({ field }) => (
                  <input
                    maxLength={50}
                    autoComplete="off"
                    {...field}
                    type="text"
                    className="form-control"
                    placeholder="Currency holding plan"
                  />
                )}
              />
              {errors.planName?.type === "required" && (
                <span className="errorMessage">
                  {" "}
                  A product name is required and recommended to be unique.
                </span>
              )}
            </div>

            <div className="col-12 fieldPadding">
              <label className="labelForm" htmlFor="">
                Price*{" "}
              </label>
              <Controller
                control={control}
                className="form-control"
                name="price"
                rules={{ required: true }}
                render={({ field }) => (
                  <input
                    {...field}
                    autoComplete="off"
                    type="number"
                    className="form-control"
                    placeholder="Price"
                  />
                )}
              />
              {errors.price?.type === "required" && (
                <span className="errorMessage">Price is required.</span>
              )}
            </div>

            <div className="col-12 fieldPadding">
              <label className="labelForm" htmlFor="">
                Currency*{" "}
              </label>
              <Controller
                name="currency"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    theme={SELECT_BOX_THEME}
                    styles={CUSTOM_SELECT_STYLES}
                    className="select-border"
                    {...field}
                    options={CURRENCY_NAME}
                    isClearable={true}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    placeholder="Choose currency ..."
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                )}
              />
              {errors.planName?.type === "required" && (
                <span className="errorMessage"> Currency is required.</span>
              )}
            </div>

            <div className="col-12 fieldPadding">
              <label className="labelForm" htmlFor="">
                Description*
              </label>
              <Controller
                control={control}
                name="targetAudience"
                rules={{ required: true }}
                render={({ field }) => <ReactQuill theme="snow" {...field} />}
              />
              {errors.targetAudience?.type === "required" && (
                <span className="errorMessage">
                  Brief description of your target demographic (e.g. For
                  individuals seeking wealth accumulation...)
                </span>
              )}
            </div>
            <KimbocorpToggle
              checked={isKimbocorp}
              onChange={(e) => setIsKimbocorp(e.target.checked)}
            />

            <div className="row bottomRow resultCol">
              <div className="col-12 col-md-6 mb-2 mb-md-0 btnSection d-flex justify-content-center justify-content-md-start">
                <button
                  onClick={onCancel}
                  disabled={planPreviewLoader}
                  type="button"
                  className="btn save-btn cancelButton"
                >
                  Cancel
                </button>
              </div>
              <div className="col-12 col-md-6 btnSection d-flex justify-content-center justify-content-md-end">
                <button
                  type="submit"
                  disabled={planPreviewLoader}
                  onClick={handleSubmit(onSubmit)}
                  // onClick={previewPlanFunc}
                  className="btn save-btn customConfirmButton d-flex align-items-center justify-content-center"
                >
                  {planPreviewLoader && <div className="spinner me-2"></div>}
                  Preview
                </button>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas>
      <Offcanvas
        show={showNewSlider}
        onHide={() => {
          setShowNewSlider(false);
          setPlanCreateLoader(false)
        }}
        placement="end" // 👈 slide from right
        className="plan-summary-offcanvas filter-offcanvas canvasSidebar filter-modal"
      >
        <div className="offcanvas-header pt-2 custom-canvas-header1">
          <div className="compSideBarHeader">
            View summary
            <p className="m-0">
              Almost done! Here’s an overview of your payout.
            </p>
          </div>
          <button
            type="button"
            className="btn-close text-dark close-button"
            onClick={() => {
              setShowNewSlider(false);
              setPlanCreateLoader(false)
            }}
          >
            &nbsp;
            {/* <span aria-hidden="true">×</span> */}
          </button>
        </div>
        <Offcanvas.Body>
          <PlanSummary planPreview={planPreview} isKimbocorp={isKimbocorp} values={planPayload} />
          <div className="row bottomRow resultCol">
            <div className="col-12 col-md-6 mb-2 mb-md-0 btnSection d-flex justify-content-center justify-content-md-start">
              <button
                onClick={() => setShowNewSlider(false)}
                type="button"
                disabled={planCreateLoader}
                className="btn save-btn cancelButton"
              >
                Go back
              </button>
            </div>
            {isChatPage ?
              <div className="col-12 col-md-6 btnSection d-flex justify-content-center justify-content-md-end">
                <button
                  type="submit"
                  disabled={planCreateLoader}
                  onClick={() => createPlan(true)}
                  // onClick={previewPlanFunc}
                  className="btn save-btn customConfirmButton d-flex align-items-center justify-content-center"
                >
                  {planCreateLoader && <div className="spinner me-2"></div>}
                  Proceed
                </button>
              </div>
              :
              <div className="col-12 col-md-6 mb-2 mb-md-0 btnSection d-flex justify-content-center justify-content-md-start">
                <button
                  type="button"
                  disabled={planCreateLoader}
                  onClick={() => createPlan(false)}
                  className="btn save-btn customConfirmButton d-flex align-items-center justify-content-center">
                  {planCreateLoader && <div className="spinner me-2"></div>}
                  Copy payment link
                </button>
              </div>
            }
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
